import loadable from '@loadable/component';

export const CartDropdownButtonContainerLoadable = loadable(
  () => import('./CartDropdownButtonContainer'),
  { resolveComponent: (module) => module.CartDropdownButtonContainer },
);
